import { render } from "./ModalCriarTarefaCorrecao.vue?vue&type=template&id=40a41e9a"
import script from "./ModalCriarTarefaCorrecao.vue?vue&type=script&lang=js"
export * from "./ModalCriarTarefaCorrecao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__